import { query, Query, QueryHandlerFunction, QueryHandlerFunctionArgs } from "@lookiero/messaging";
import { OfferingsProjection } from "../offering/offering";
import { viewIsCategoriesOfferingEnabled } from "../offering/viewIsCategoriesOfferingEnabled";
import { viewIsCompleteYourLookOfferingEnabled } from "../offering/viewIsCompleteYourLookOfferingEnabled";
import { viewIsSalesOfferingEnabled } from "../offering/viewIsSalesOfferingEnabled";
import { viewIsTrendingForYouOfferingEnabled } from "../offering/viewIsTrendingForYouOfferingEnabled";

const VIEW_IS_LOOK_IN_ENABLED = "view_is_look_in_enabled";

interface ViewIsLookInEnabled extends Query<typeof VIEW_IS_LOOK_IN_ENABLED> {}

interface ViewIsLookInEnabledFunction {
  (): ViewIsLookInEnabled;
}

const viewIsLookInEnabled: ViewIsLookInEnabledFunction = () => query({ name: VIEW_IS_LOOK_IN_ENABLED });

interface ViewIsLookInEnabledReturn {
  readonly enabled: boolean;
  readonly offerings: OfferingsProjection;
}

interface ViewIsLookInEnabledHandlerFunctionArgs extends QueryHandlerFunctionArgs {}

const viewIsLookInEnabledHandler: QueryHandlerFunction<
  ViewIsLookInEnabled,
  ViewIsLookInEnabledReturn,
  ViewIsLookInEnabledHandlerFunctionArgs
> =
  ({ queryBus }) =>
  async () => {
    const offerings = await Promise.all<boolean>([
      queryBus(viewIsCompleteYourLookOfferingEnabled()),
      queryBus(viewIsCategoriesOfferingEnabled()),
      queryBus(viewIsSalesOfferingEnabled()),
      queryBus(viewIsTrendingForYouOfferingEnabled()),
    ]);

    const enabled = offerings.some((offering) => offering === true);

    return {
      enabled,
      offerings: {
        completeYourLook: offerings[0] ?? false,
        categories: offerings[1] ?? false,
        sales: offerings[2] ?? false,
        trendingForYou: offerings[3] ?? false,
      },
    };
  };

export type { ViewIsLookInEnabledReturn };
export { VIEW_IS_LOOK_IN_ENABLED, viewIsLookInEnabled, viewIsLookInEnabledHandler };
